module.exports = __webpack_public_path__ + "img/expand.e38c0755.svg";